import { makePublicUrl } from 'app/utils/publicUrl'

export interface SupportedActions {
  id: number
  name: string
  iconUrl: string
}

export const SUPPORTED_ACTIONS: SupportedActions[] = [
  {
    id: 1,
    name: 'start',
    iconUrl: makePublicUrl('images/systemMonitor/start.svg'),
  },
  {
    id: 2,
    name: 'stop',
    iconUrl: makePublicUrl('images/systemMonitor/stop.svg'),
  },
  {
    id: 3,
    name: 'restart',
    iconUrl: makePublicUrl('images/systemMonitor/restart.svg'),
  },
  {
    id: 4,
    name: 'close',
    iconUrl: makePublicUrl('images/systemMonitor/cross.svg'),
  },
]

export const [startAction, stopAction, restartAction, closeAction] =
  SUPPORTED_ACTIONS

export const requiresSystemAccessMsg =
  'You don’t have permission to manage processes. Request system access.'
